import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelfVerificationService } from '../service/self-verification.service';
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';
import { ActivatedRoute } from '@angular/router';
export interface Person {
  mdmid: string;
  title: string;
  firstName:string,
  lastName:string,
  email:string,
  phoneNumber:string,
  nationalId:string,
  passportNumber:any,
  nationality:string,
  personnelArea:string,
  personnelSubareaName:string,
  employeeType:string,
  companyName:string,
  companyNationalId:string,
  organizationalLevel:string,
  companyEmail:string,
  oneUp:any
}


@Component({
  selector: 'app-external-verification-details',
  templateUrl: './external-verification-details.component.html',
  styleUrls: ['./external-verification-details.component.css']
})
export class ExternalVerificationDetailsComponent implements OnInit {
  sites: any = [];
  typeEmployee:string;
  email:any;
  rut: any;
  person:Person;
  typePeopleContractor:boolean;
  title = 'RUT'
  constructor(private dataApi: SelfVerificationService,
    private _snackBar: MatSnackBar, public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute) {
      debugger;
      this.route.snapshot.paramMap.get('email');
      this.email = this.route.snapshot.paramMap.get('email').split('-*')[0];
      this.rut = this.route.snapshot.paramMap.get('email').split('-*')[1];
      this.title = this.route.snapshot.paramMap.get('email').split('-*')[2];
    }

  ngOnInit() {
    debugger;
    this.searchPerson(this.email, this.rut);
  }

  getlang(){

    return sessionStorage.getItem('lang');
  }
  searchPerson(email, rut){
    this.spinner.show("loading");
    this.dataApi.getSearchExternalMailRut(email, rut).subscribe(
      (data: any)=>{
        this.spinner.hide("loading");
        if(data==null || data==undefined || data.length==0){
          this.person= null;

        }else{
          this.person=  data[0];
          if(this.person.employeeType == "Employee")
              this.typePeopleContractor = false;
          else
              this.typePeopleContractor = true;
          this.getQualificationsSelfCheck(this.person.mdmid)

        }
      },
      (err: any)=>{
        this.person= null;
        this.spinner.hide("loading");

      }
    );

  }

  getQualificationsSelfCheck(mdmid){
    this.spinner.show("loadingSecond");
      this.dataApi.getQualificationsSelfCheck(mdmid).subscribe(
        (data)=>{
          if(data){
            this.typeEmployee = data.employeeType;
            this.sites = data.sites;
            
          }else{
            this.sites = []

          }
          this.spinner.hide("loadingSecond");
        },
        (err)=>{
          this.spinner.hide("loadingSecond");
          if(err.error.error !== 'Invalid token.') {
            this.dialog.open(ModErrorComponent, {
              width: 'auto',
              panelClass: 'myapp-no-padding-dialog',
            });
          }
        })
  }


}
